import { AvatarWebElementBase } from './AvatarWebElementBase';

/**
 * The component WebElement for [oj-c-avatar](../../jsdocs/oj-c.Avatar.html).
 * Do not instantiate this class directly, instead, use
 * [findAvatar](../functions/findAvatar.html).
 */
export class AvatarWebElement extends AvatarWebElementBase {
  // Put overrides here
}
